export default __webpack_public_path__ + "static/media/img4.491576dc.jpg";